import { CALENDAR_VIEW_OPTIONS, CalendarViewMode } from './CalendarViewMode';

type CalendarViewSelectorProps = {
  value: CalendarViewMode;
  onChange: (value: CalendarViewMode) => void;
};

export function CalendarViewSelector({ value, onChange }: CalendarViewSelectorProps) {
  return (
    <label className="inline-flex items-center gap-2 text-sm text-slate-700">
      <span className="sr-only">Visualização</span>
      <select
        className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm font-medium hover:bg-slate-50"
        value={value}
        onChange={(event) => onChange(event.target.value as CalendarViewMode)}
      >
        {CALENDAR_VIEW_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
